import {Module} from "vuex";
import {RootState} from "@/store/types";
import {PharmaciesState} from "@/store/pharmacies/types";
import getters from "@/store/pharmacies/getters";
import mutations from "@/store/pharmacies/mutations";
import actions from "@/store/pharmacies/actions";

const pharmacies:Module<PharmaciesState, RootState> = {
    namespaced: true,
    state: {
        pharmacies_arr: [],
        FRV: null,
        error_modal: null,
        corestaff_count_panel: null,
        old_corestaff: 0,
        frv_rv_count_panel: null,
        old_frv_rv: 0,
        // Панели счётчиков для модалки создания потребности Беру (могут содержать ФРВ следующего месяца)
        beru_corestaff_count_panel: null,
        beru_frv_rv_count_panel: null,
        // Праздники для модалки создания потребности Беру (могут быть за следующий месяц)
        beru_holidays: null,
        pharm_users: [],
        pharm_pst_users: [],
        time_schedule: null,
        time_schedule_details: null,
        time_schedule_details_past: null,
        admin_shift: null,
        FRV_human: null,
        pharm_schedule: null,
        pharm_holidays: null,
        shift_existence: null,
        time_schedule_key: null,
        pharmId: null,
        oldShift: null,
        pharms_skip: 0,
        pharms_count: 0,
        pharms_take: 10,
        pharms_list: [],
        pharms_search: '',
        search_user_skip: 0,
        search_user_count: 0,
        search_user_take: 5,
        search_user_list: null,
        search_user_search: '',
        active_shift_details: null,
        shift_info: null,
        pharmTz: 0,
        admin_shift_buffer: null,
        tomorrow_worktime: null
    },
    getters: getters,
    mutations: mutations,
    actions: actions
}

export default pharmacies